// src/utils/menuHelper.ts (veya Sidebar içinde)

// src/utils/menuHelper.ts
export const getFilteredMenu = (user: any, allMenuItems: any) => {
  if (!user) return [];

  const roleName = user?.role?.name || "";
  const permissions = user?.role?.permissions || [];
  const firmModules = user?.firmModules || {}; // Backend'den gelen abonelik nesnesi

  // 1. Paket Süresi Kontrolü (Opsiyonel ama önerilir)
  const isExpired = firmModules.expiresAt && new Date(firmModules.expiresAt) < new Date();

  // 2. Rol bazlı menü seçimi
  const baseMenu: any[] = allMenuItems[roleName] || allMenuItems["firm_admin"];

  // Super Admin kısıtlamalara takılmaz
  if (roleName === "super_admin") return baseMenu;

  return baseMenu.map(group => ({
    ...group,
    items: group.items.filter((item: any) => {
      // Modül zorunluluğu yoksa (Dashboard vb.) göster
      if (!item.module) return true;

      const isSystemRole = ["super_admin", "admin", "firm_admin"].includes(roleName);

      // KONTROL 1: Firma bu modülü satın almış mı? (JSON'daki true/false değeri)
      const isSubscribed = firmModules[item.module] === true;

      // KONTROL 2: Kullanıcının bu modülü görme yetkisi var mı? (Sistem rolleri her zaman görür)
      const hasPermission = isSystemRole || permissions.some(
        (p: any) => p.module === item.module && p.canRead === true
      );

      // KONTROL 3: Firmanın paket süresi dolmuş mu?
      const isAccessAllowed = !isExpired;

      return isSubscribed && hasPermission && isAccessAllowed;
    })
  })).filter(group => group.items.length > 0);
};